export enum Role {
    ADMIN = "ADMIN",
    FSE = "FSE",
    TSE = "TSE",
    SYS = "SYS",
    RM="RM"

}